<div class="BarUp">
  <div class="Link2">
    <a routerLink="add" class="nav-link">Aggiungi Prodotto</a>
  </div>
  <div class="Menu">
    <img  src="../../assets/Logo.png" width="20%">
  </div>
  <div class="Link">
    <div class="Home-Page">
      <a href="/">Home Page</a>
    </div>
    <div class="Carrello">
      <a routerLink="/cart">Carrello</a>
      <img  src="../../assets/carrello.jpg" width="15%" height="15%">
    </div>
  </div>
</div>
